export default __webpack_public_path__ + "static/media/icon_parking.51339381.svg";